import { render, staticRenderFns } from "./GithubRepo.vue?vue&type=template&id=547f67df&"
import script from "./GithubRepo.vue?vue&type=script&lang=js&"
export * from "./GithubRepo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports